import { APPCONSTANT } from "../Constants/AppConstant.js";
import { REFRESH } from "../Constants/PathConstant.js";
import { EVN } from "../Helper/APIParam.js";
import network, { Method } from "./../NetworkManager/NetworkManager.js";
import app from "./App.js";

class InitializeSDK {
	async config(init = { token, environment, custom_header }) {
		APPCONSTANT.TOKEN = init.token;
		APPCONSTANT.ENVIRONMENT = init.environment;
		APPCONSTANT.CUSTOM_HEADER = init.custom_header
			? init.custom_header
			: {};
	}
	async refreshAPI(refreshKey) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: REFRESH,
				method: Method.GET,
				refreshKey: refreshKey,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
}
const initSdk = new InitializeSDK();
export default initSdk;
